import React, { useEffect, useState } from "react";
import useApiToken from "../../hooks/useApiToken";
import { useParams } from "react-router-dom";
import { RoleStatus } from "../../Models";
import { GetInterviewSlotById, GetStatusForRole } from "../../api/roles.api";

export default function SelectRoleStatus({
  commentType,
  handleCommentType,
}: {
  commentType: string;
  handleCommentType: (t: string) => void;
}) {
  const [roleStatus, setRoleStatus] = useState<RoleStatus[]>([]);
  const token = useApiToken();
  const { roleId } = useParams();
  const { slotId } = useParams();

  useEffect(() => {
    if (!token) return;

    const fetchStatus = async () => {
      try {
        let roleToUse = roleId;

        if (slotId) {
          const slot = await GetInterviewSlotById(slotId, token);
          roleToUse = slot.roleId;
        }

        if (!roleToUse) return;

        const sr = await GetStatusForRole(roleToUse, token);
        setRoleStatus(
          sr.roleStatuses
            .sort((a, b) => a.order - b.order)
            .slice(1, -2)
        );
      } catch (error) {
        console.error("Error fetching role status:", error);
      }
    };

    fetchStatus();
  }, [token, slotId, roleId]);

  return (
    <select
      id="grade"
      value={commentType}
      onChange={(e) => handleCommentType(e.target.value)}
      className="pl-3 pr-8 py-1.5 text-xs font-medium rounded-lg border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-300 cursor-pointer focus:outline-none focus:ring-1 focus:ring-entntblue focus:border-transparent transition-all"
    >
      <option value="">All stages</option>
      {roleStatus.map((rs) => (
        <option key={rs.id} value={rs.id}>
          {rs.name}
        </option>
      ))}
    </select>
  );
}